module.exports = __webpack_public_path__ + "fonts/DM_Sans-700-latin-ext14.0d3827b.woff2";